import query from '@/components/query/query-constructor';

export const pushURL = (ctx: any, cb?: Function) => {
  if (ctx.$route.name !== 'app.postbacks' || !ctx.$store.getters.savedColumnsInCurentPreset)
    return;

  const {
    from,
    to,
    timezone,
    date,
    compareFrom,
    compareTo,
    compareDate,
    compareEnabled,
    currency,
    limit,
    offset,
    postbackStatus,
  } = ctx.$store.getters.tableQueryForCurrentTab;

  const { columns, order, context } = ctx.$store.getters.savedColumnsInCurentPreset.postbacks;
  const data = query.get({
    from,
    to,
    timezone,
    date,
    compareFrom,
    compareTo,
    compareDate,
    compareEnabled,
    currency,
    limit,
    offset: offset[context],
    ...order,
    columns,
    postbackStatus,
    groupBy: context,
  });
  
  ctx.$router.replace({
    name: 'app.postbacks',
    params: {
      data: data,
      report: ctx.$route.params.report,
      manual: true,
      picker: true 
    }
  }, cb, cb);
};
